import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {DrinkInfoModel} from "./drink-info-model";
import {CoinInfoModel} from "./coin-info-model";
/**
 * Created by vidhyasagar on 05.04.18.
 */


@Injectable()
export class DrinkMachineStorageService{


  drinkInfoLocalStorage:Array<DrinkInfoModel> = [];
  coinInfoLocalStorage:Array<CoinInfoModel> = [];


  constructor(private _http:HttpClient){

  }

  /**
   *
   * @returns {Array<DrinkInfoModel>}
   */
  getDrinkInfoLocalStorage() {
    return this.drinkInfoLocalStorage;
  }


  /**
   * It fetches the drink info data from backend or in memory and
   * store it here to access all over the app.
   *
   */

  fetchAndStoreDrinkInfo(){

    this._http.get<DrinkInfoModel[]>("./assets/data/drink_info_mockdata.json").subscribe(data => {

       this.drinkInfoLocalStorage = data;

      console.log("data test after st" + JSON.stringify(this.drinkInfoLocalStorage));

    })

  }

  /**
   * It fetches the coin info data from backend or in memory and
   * store it here to access all over the app.
   *
   */
  fetchAndStoreCoinInfo(){


    this._http.get<CoinInfoModel[]>("./assets/data/coin_info_mockdata.json").subscribe(data => {

      console.log("received coins " + JSON.stringify(data));
      this.coinInfoLocalStorage = data;
    })

  }


  /**
   *
   * Here we fill the coins in the machine.
   *
   * @param coinValue
   */
  fillMachineCoins(coinVal:number){

    this.coinInfoLocalStorage.forEach(coinInfo => {

      if(coinInfo.coinValue == coinVal){

        coinInfo.numberOfCoinsAvailable = coinInfo.numberOfCoinsAvailable + 1;

      }

    })

  }


}



// WEBPACK FOOTER //
// /Applications/WebStorm.app/Contents/bin/untitled3/Users/vidhyasagar/WebstormProjects/RealTimeAnalytics/CoinMachine/src/app/Services/DrinkMachineService/drink-machine-config-service.ts